import {h, Component} from 'preact';
import OnPasswordUpdated from '../tags/on-password-updated';
import NavigationService from "../../services/navigation";

export default class PasswordUpdated extends Component {
    constructor() {
        super();
        this.state = {
            showPassword: false
        }
    }

    goToUserApp = () => {
        NavigationService.goToWebappUrl('/');
    };

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    render({getPassword}, {showPassword}) {
        return(
            <div className='form'>
                <h2>Password updated</h2>
                <OnPasswordUpdated getPassword={getPassword} />
                <div className='bottom-buttons clearfix'>
                    <a className='button button-prime pull-right' onClick={this.goToUserApp}>Continue</a>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/change-password/password-updated.js